import { PublicEstimateRequestPage } from "features/EstimateRequest/pages/PublicEstimateRequestFormPage";

export default PublicEstimateRequestPage;
